import { useCallback, useState } from "react";
import ChatBot from "./ChatBot";
import { CategoryType, MonthEnum, PadithiEnum, PredictionType } from "../utils/enums";
import { UserCharts } from "./user-charts";
import FilterForm from "./predictions/FilterForm";
import { createGetPredictionPayload } from "./predictions/prediction.util";
import { getSandboxUserPredictions } from "./predictions/predictionService";
import PredictionTimeline from "./predictions/PredictionTimeline";
import PredictionView from "./predictions/prediction-view/PredictionView";
import { getCurrentDayInTimezone, getMonthAccordingToBirthdayDay } from "../utils/dateFromat";
import { Box } from "@mui/material";
import Loading from "./loading/Loading";
import DataNotFound from "./not-found/DataNotFound";
import AlertMessage from "./alert/AlertMessage";
import UserProfileModal from "./predictions/user-profile/UserProfileModal";
import AppDivider from "./divider/AppDivider";

const PredictionPage = ({ userId, currentUser }) => {

    const [predictionsData, setPredictionData] = useState(null);

    const [isFetched, setIsFetched] = useState(false);

    const [predictionError, setPredictionError] = useState(null);

    const [loading, setLoading] = useState(false);

    const birthDate = currentUser?.birthDetails?.date;
    const birthTZ = currentUser?.birthDetails?.timezone;

    const userCurrentTimezone = currentUser?.userCurrentTimezone;

    const [filter, setFilter] = useState({
        conditionType: PadithiEnum.LAL_KITAB,
        category: CategoryType.PROMISE,
        predictionType: PredictionType.YEAR,
        month: MonthEnum.CURRENT_MONTH,
        day: getCurrentDayInTimezone(userCurrentTimezone),
    })

    // const handleFilterChange = (data) => {
    //     setFilter(data);
    // }

    // const debouncedFilter = useDebounce(filter, 300);

    // useEffect(() => {
    //     const fetchPredictions = async () => {
    //         if (loading) return;
    //         let payload = createGetPredictionPayload(debouncedFilter);
    //         const userId = currentUser?._id;
    //         const userCurrentTimezone = currentUser?.userCurrentTimezone;

    //         payload = { ...payload, userId, userCurrentTimezone };

    //         if (payload.month && payload.month === MonthEnum.CURRENT_MONTH) 
    //             payload.month = getMonthAccordingToBirthdayDay(birthDate, userCurrentTimezone, birthTZ);
    //             // payload.month = getCurrentMonthInTimezone(userCurrentTimezone);


    //         if (payload.conditionType === PadithiEnum.LAL_KITAB) {
    //             if (payload.predictionType === PredictionType.MONTH) {
    //                 if (!payload.month || payload.day) return;
    //             } else if (payload.predictionType === PredictionType.DAY) {
    //                 if (!payload.month || !payload.day) return;
    //             }
    //         }

    //         try {

    //             setLoading(true);
    //             setPredictionError(null);

    //             const response = await getSandboxUserPredictions(payload);
    //             setPredictionData(response?.data);

    //         } catch (error) {
    //             setPredictionError(
    //                 error.message || "Failed to load predictions"
    //             );
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchPredictions();

    // }, [debouncedFilter]);

    const handleGetPredictions = useCallback(
        async (data) => {
            if (loading) return;
            let payload = createGetPredictionPayload(data);
            const userId = currentUser?._id;

            payload = { ...payload, userId, userCurrentTimezone };

            if (payload.month && payload.month === MonthEnum.CURRENT_MONTH)
                payload.month = getMonthAccordingToBirthdayDay(birthDate, userCurrentTimezone, birthTZ);

            if (payload.conditionType === PadithiEnum.LAL_KITAB) {
                if (payload.predictionType === PredictionType.MONTH) {
                    if (!payload.month || payload.day) return;
                } else if (payload.predictionType === PredictionType.DAY) {
                    if (!payload.month || !payload.day) return;
                }
            }
            try {
                setFilter(data)
                setLoading(true);
                setPredictionError(null);

                const response = await getSandboxUserPredictions(payload);
                setPredictionData(response?.data);

            } catch (error) {
                setPredictionError(
                    error.message || "Failed to load predictions"
                );
            } finally {
                setLoading(false);
                if (!isFetched) setIsFetched(true)
            }
        },
        [currentUser, birthDate, birthTZ, userCurrentTimezone, isFetched, loading]
    );

    return (
        <>
            <Box
                sx={{
                    bgcolor: "background.paper",
                    px: 0.5,
                    borderRadius: 1,
                    boxShadow: 1,
                }}
            >
                <Box sx={{ mb: 6 }}>
                    <UserCharts
                        userId={userId}
                        user={currentUser}
                        padithi={filter.conditionType}
                        // selectedYear={Number(selectedDay)} 
                        selectedMonth={filter?.month}
                        selectedDay={(filter?.predictionType === PredictionType.DAY) ? Number(filter?.day) : null}
                        predictionType={filter.predictionType}
                    />
                </Box>

                {/* Filter form */}
                {userId && currentUser &&
                    <>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            width="100%"
                            className="mb-4"
                        >
                            <Box flex={1}>
                                <FilterForm
                                    isLoading={loading}
                                    defaultValues={filter}
                                    user={currentUser}
                                    onSubmit={handleGetPredictions}
                                />
                            </Box>
                            <UserProfileModal
                                user={currentUser}
                            />
                        </Box>
                        <AppDivider />
                    </>
                }

                {loading && <Loading text="Loading Predictions..." />}

                {predictionError && !loading && !predictionsData && (
                    <AlertMessage
                        type="error"
                        message={predictionError}
                    />
                )}
                {!loading && !predictionError && predictionsData && (
                    <>
                        {filter.conditionType === PadithiEnum.LAL_KITAB &&
                            <PredictionTimeline
                                filter={filter}
                                user={currentUser}
                            />
                        }
                        <PredictionView
                            predictionData={predictionsData}
                            user={currentUser}
                            filter={filter}
                        />
                    </>)}

                {isFetched && !loading && !predictionsData && !predictionError && (
                    <DataNotFound message="No predictions found for the selected category and period." />
                )}
            </Box>
            {/* Floating ChatBot */}
            <ChatBot
                currentUser={currentUser}
            />

        </>
    );
};

export default PredictionPage;
